/* eslint-disable react-hooks/exhaustive-deps */
import { Form, Button } from 'antd'
import { useRouter } from 'next/router'
import React, { useEffect } from 'react'
import { useTranslation } from 'next-i18next'
import { showNotification } from 'src/core/helpers'
import { useAppDispatch, useAppSelector } from 'src/app/hooks'
import { CustomTextInput, CustomText, CustomTitle } from 'src/components'
import { forgotPasswordSelector, requestRestorePassword, resetForgotPasswordState } from 'src/features'

const ForgotPasswordForm: React.FC = () => {
  const { t } = useTranslation()
  const [form] = Form.useForm()
  const dispatch = useAppDispatch()
  const router = useRouter()

  const { loading: loadingResquest, success: successRequest } = useAppSelector(forgotPasswordSelector)

  const onFinish = ({ email }: { email: string }) => {
    dispatch(requestRestorePassword(email))
  }

  useEffect(() => {
    if (successRequest) {
      showNotification('success', t('Auth.Password.EmailSended'))
      dispatch(resetForgotPasswordState())
      form.resetFields()
      router.push('/auth/login')
    }
  }, [successRequest])

  return <Form
    name='basic'
    onFinish={onFinish}
    autoComplete='off'
    form={form}
  >
    {/* Email */}
    <CustomTitle label={t('admin.Brokerage.Email')} className='label-input' />
    <CustomText label={t('Auth.Password.EmailLabel')} type='secondary' />

    <CustomTextInput
      name={'email'}
      placeholder={t('admin.Brokerage.EmailPlaceHolder')}
      type='email'
      required
    />

    <Button
      block
      size='large'
      type='primary'
      htmlType='submit'
      className='radius-100'
      loading={loadingResquest}
    >
      {loadingResquest ? t('Auth.Password.SendingRequest') : t('Auth.Password.RequestRestore')}
    </Button>
  </Form>
}

export default ForgotPasswordForm
